import React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { WidgetCard, WidgetEmptyState } from './WidgetCard';
import { buildHistogram } from './widgetData';

const HistogramWidget = ({ widget, rows }) => {
  const { title, valueField, bins, min, max, showLegend } = widget.params || {};
  const { labels, counts } = buildHistogram({ rows, valueField, bins, min, max });

  if (!labels.length) {
    return (
      <WidgetCard
        title={title || 'Histogram'}
        subtitle={valueField}
        testId={`report-widget-${widget.id || widget.type}`}
      >
        <WidgetEmptyState message="Histogram data is not available yet." />
      </WidgetCard>
    );
  }

  return (
    <WidgetCard
      title={title || 'Histogram'}
      subtitle={valueField}
      testId={`report-widget-${widget.id || widget.type}`}
    >
      <BarChart
        height={240}
        xAxis={[{ data: labels, scaleType: 'band' }]}
        series={[{ data: counts, label: title || 'Histogram' }]}
        legend={{ hidden: !showLegend }}
      />
    </WidgetCard>
  );
};

export default HistogramWidget;
